<template>
  <div
    v-if="storeList.length > 0"
    class="modal_wrap bottom_modal review_reminder_modal"
    :class="{ on: show }"
  >
    <div class="modal_inner">
      <div class="modal">
        <div class="close_txt" v-if="show">
          <p class="pnt" @click="close(false)">
            닫기<img
              :src="require('@/assets/front/images/i_x_pop_s.png')"
              alt=""
            />
          </p>
        </div>
        <div class="main_con">
          <h3>{{ title }}</h3>
          <p class="txt">매장리뷰를 작성하여 경험을 공유해주세요!</p>
          <div class="store_list">
            <Swiper
              ref="reviewSwiper"
              :options="swiperOption"
              @slideChange="onSlideChange"
              :pagination="true"
            >
              <!-- <Swiper :options="swiperOption"> -->
              <SwiperSlide v-for="(store, index) in storeList" :key="index">
                <div class="store_list_wrap">
                  <div class="store_list nodrag">
                    <div class="base">
                      <div class="list_thumb">
                        <div class="n_thumb">
                          <div class="n_thumb_inner">
                            <img
                              v-if="store.storeProfile"
                              :src="store.storeProfile"
                              alt=""
                            />
                            <img
                              v-else
                              :src="
                                setShopProfileImg(
                                  store.storeName,
                                  store.storeId,
                                )
                              "
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div class="store_info">
                        <div class="ttl">
                          <h1>
                            {{ store.storeName }}
                            <span v-if="store.cert === 1">
                              <img
                                src="@/assets/front/images/new/icon_consent_s.png"
                              />
                            </span>
                          </h1>
                          <p>{{ store.address }} {{ store.addressDetail }}</p>
                        </div>
                        <div class="shop_index_wrap">
                          <div class="shop_index">
                            <dl>
                              <dd class="score_dd">
                                <div
                                  class="score"
                                  :data-score="
                                    Math.floor(store.evaluationScore)
                                  "
                                >
                                  <ul>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                  </ul>
                                </div>
                              </dd>
                              <dd class="review">
                                {{ Number(store.evaluationScore).toFixed(1) }}점
                                ({{ store.reviewCnt }}건)
                              </dd>
                            </dl>
                          </div>
                          <div class="shop_index">
                            <dl>
                              <dt>응답률</dt>
                              <dd
                                v-if="
                                  store.chatCnt > 0 && store.responseRate > 0
                                "
                              >
                                {{
                                  store.responseRate > 100
                                    ? 100
                                    : store.responseRate
                                }}%
                              </dd>
                              <dd v-else style="padding:0 0.5rem">-</dd>
                              <dd
                                v-if="
                                  store.responseMinute >= 0 &&
                                    store.responseMinute <= 10 &&
                                    store.chatCnt > 0 &&
                                    store.responseRate > 0
                                "
                                style="margin-left:0.2rem"
                              >
                                (10분 이내)
                              </dd>
                              <dd
                                v-if="
                                  store.responseMinute > 10 &&
                                    store.responseMinute <= 30 &&
                                    store.chatCnt > 0
                                "
                                style="margin-left:0.2rem"
                              >
                                (30분 이내)
                              </dd>
                              <dd
                                v-if="
                                  store.responseMinute > 30 &&
                                    store.responseMinute <= 60 &&
                                    store.chatCnt > 0 &&
                                    store.responseRate > 0
                                "
                                style="margin-left:0.2rem"
                              >
                                (1시간 이내)
                              </dd>
                              <dd
                                v-if="
                                  store.responseMinute > 60 &&
                                    store.responseMinute <= 120 &&
                                    store.chatCnt > 0 &&
                                    store.responseRate > 0
                                "
                                style="margin-left:0.2rem"
                              >
                                (2시간 이내)
                              </dd>
                              <dd
                                v-if="
                                  store.responseMinute > 120 &&
                                    store.responseMinute <= 360 &&
                                    store.chatCnt > 0 &&
                                    store.responseRate > 0
                                "
                                style="margin-left:0.2rem"
                              >
                                (6시간 이내)
                              </dd>
                              <dd
                                v-if="
                                  store.responseMinute > 360 &&
                                    store.chatCnt > 0 &&
                                    store.responseRate > 0
                                "
                                style="margin-left:0.2rem"
                              >
                                (6시간 이상)
                              </dd>
                              <dt class="chat_cnt">상담</dt>
                              <dd>{{ store.chatCnt }}건</dd>
                            </dl>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <div class="swiper-pagination" slot="pagination"></div>
            </Swiper>
          </div>
        </div>
        <div class="btm_btn">
          <button class="btn" @click="close(true)">매장리뷰 쓰러가기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setShopProfile } from '@common/lib/common/utils';

import { mapActions as reviewMapActions } from '@common/store/modules/review';
import * as reviewTypes from '@common/store/modules/review/types';

import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
// Import Swiper styles
import 'swiper/swiper.scss';
export default {
  name: 'ReviewCheck',
  description: '리뷰 리마인더',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    show: Boolean,
  },
  computed: {
    swiper() {
      return this.$refs.reviewSwiper.$swiper;
    },
  },
  data() {
    return {
      titles: [
        { title: '상담을 완료하셨나요?' },
        { title: '즐거운 상담 하셨나요?' },
        { title: '만족스러운 상담을 하셨나요?' },
        { title: '상담한 매장을 평가해주세요!' },
        { title: '매장과의 상담은 어떠셨나요?' },
      ],
      title: '상담을 완료하셨나요?',
      list: [],
      swiperOption: {
        slidesPerView: 'auto',
        pagination: {
          el: '.swiper-pagination',
        },
      },
      key: 'review-reminder',
      hideOneday: false,
      activeIndex: 0,
      storeList: [],
      startDate: '',
      endDate: '',
    };
  },
  async created() {
    this.getRandomTitle();
  },
  methods: {
    ...reviewMapActions([
      reviewTypes.FETCH_REVIEW_CHECK,
      reviewTypes.UPDATE_REVIEW_POPUP,
      reviewTypes.UPDATE_REVIEW_POPUP,
    ]),
    getRandomTitle() {
      let random = this.titles[Math.floor(Math.random() * this.titles.length)];
      this.title = random.title;
    },
    async checkReviewList() {
      this.list.forEach(item => {
        console.log(item.storeId);
        // 1:1문의 채팅일 경우 storeId가 없기 때문에 조건 추가
        if (item.storeId > 0) {
          this[reviewTypes.FETCH_REVIEW_CHECK]({
            storeId: item.storeId,
          }).then(res => {
            if (res.reviewed === 0 && res.chat > 0) {
              this.storeList.push(item);
            }
          });
        }
      });
      console.log('this.storeList :: {}', this.storeList);
    },
    close(dataType) {
      // 팝업 확인 처리
      const parmas = {
        startDate: this.startDate,
        endDate: this.endDate,
      };
      this[reviewTypes.UPDATE_REVIEW_POPUP](parmas);

      if (dataType) {
        // 매장 리뷰 쓰러 가기
        const shop = this.storeList[this.activeIndex];
        this.$router.push({
          name: 'Shops.WriteReview',
          params: { id: shop.storeId },
          query: { type: 'normal' },
        });
      }
      this.$emit('close');
    },
    onSlideChange() {
      this.activeIndex = this.swiper.activeIndex;
    },
    setShopProfileImg(shopName, shopId) {
      console.log(this.shop);
      let path = setShopProfile(shopName, shopId, '150x150');

      return path;
    },
  },
};
</script>
